import { List, ListItem, Box, ListItemText, ListItemIcon, Grid } from '@mui/material';
import { RiFileSettingsLine, RiListSettingsLine } from 'react-icons/ri';
import { Link, useLocation } from 'react-router-dom';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import useJobBoardSettings from '../../components/hooks/useJobBoardSettings';

const SettingsIndex = () => {
  const location = useLocation();

  const jobBoardResponse = useJobBoardSettings();
  const jobBoardsList = [
    {
      name: 'Monster',
      accounts: jobBoardResponse?.Monster.length ?? 0,
      link: '/job-boards/monster',
    },
    {
      name: 'Dice',
      accounts: jobBoardResponse?.Dice.length ?? 0,
      link: '/job-boards/dice',
    },
    {
      name: 'Career Builder',
      accounts: jobBoardResponse?.CareerBuilder.length ?? 0,
      link: '/job-boards/careerBuilder',
    },
    {
      name: 'Tech Fetch',
      accounts: jobBoardResponse?.TechFetch.length ?? 0,
      link: '/job-boards/techFetch',
    },
    {
      name: 'CW Jobs',
      accounts: jobBoardResponse?.CWJobs.length ?? 0,
      link: '/job-boards/cwJobs-jobposting',
    },
  ];
  const freeJobList = [
    {
      name: 'Free Job boards',
      link: '/job-boards',
    },
  ];
  return (
    <Box p={1} bgcolor="white">
      <List>
        {freeJobList.map((settings, index: number) => (
          <ListItem
            button
            key={index}
            to={settings.link}
            component={Link}
            sx={{
              background:
                location.pathname === settings.link ? WsColors.TheBlues100 : WsColors.White,
            }}
          >
            <ListItemIcon>
              <RiFileSettingsLine size={23} color={WsColors.TheBlues500} />
            </ListItemIcon>
            <ListItemText primary={`${settings.name} `} />
          </ListItem>
        ))}
        <Grid>
          <ListItem>
            <ListItemIcon>
              <RiListSettingsLine size={23} color={WsColors.TheBlues500} />
            </ListItemIcon>
            <ListItemText primary="Premium Job Boards" />
          </ListItem>
          {jobBoardsList.map((item, index) => (
            <ListItem
              button
              key={index}
              to={item.link}
              component={Link}
              sx={{
                background: location.pathname === item.link ? WsColors.TheBlues100 : WsColors.White,
                pl: 4,
              }}
            >
              <ListItemText primary={`${item.name}`} />
              <WsTypography variant={WsTypoVariants.BODY1}>{`${item.accounts}`}</WsTypography>
            </ListItem>
          ))}
        </Grid>
      </List>
    </Box>
  );
};

export default SettingsIndex;
